import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { DepositoInsumo } from '../types/DepositoInsumo.type';
import { DepositoInsumoPosicao } from '../types/DepositoInsumoPosicao.type';
import { EmpresaPainel } from '../types/EmpresaPainel.type';
import { EstoqueErpOS } from '../types/EstoqueErpOS.type';
import { InsumoConsumidoOS } from '../types/InsumoConsumidoOS.type';
import { MaterialDeposito } from '../types/MaterialDeposito.type';
import { OrdemInsumo } from '../types/OrdemInsumo.type';
import { OrdemInsumoTransferencia } from '../types/OrdemInsumoTransferencia.type';
import { Remessa } from '../types/Remessa.type';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PainelinsumoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getOrdens(apenasAbertas: boolean){
    return this.httpClient.get<OrdemInsumo[]>(`${this.configService.getApiUrlRoot()}/painelinsumos/?status=${apenasAbertas}`);
  }

  getOrdem(id: string){
    return this.httpClient.get<OrdemInsumo>(`${this.configService.getApiUrlRoot()}/painelinsumos/${id}`);
  }

  getOrdemOs(os: string, instancia: string){
    return this.httpClient.get<OrdemInsumo>(`${this.configService.getApiUrlRoot()}/painelinsumos/os/${os}/${instancia}`);
  }

  getInsumosBaixados(instancia: string, os: string, insumo: string){
    return this.httpClient.get<InsumoConsumidoOS[]>(`${this.configService.getApiUrlRoot()}/painelinsumos/insumosbaixado?instancia=${instancia}&os=${os}&insumo=${insumo}`)
  }

  postTransferir(transferencias: OrdemInsumoTransferencia){

    return this.httpClient.post<String>(`${this.configService.getApiUrlRoot()}/painelinsumos/remessas/transferir`, transferencias);
  }

  postAtender(transferencias: OrdemInsumoTransferencia){

    return this.httpClient.post<String>(`${this.configService.getApiUrlRoot()}/painelinsumos/remessas/realizarAtendimento`, transferencias);
  }

  getDepositosPorInstancia(instancia: string){

    return this.httpClient.get<DepositoInsumo[]>(`${this.configService.getApiUrlRoot()}/painelinsumos/depositos/instancia/${instancia}`)
  }

  getDepositos(){
    return this.httpClient.get<DepositoInsumo[]>(`${this.configService.getApiUrlRoot()}/painelinsumos/depositos`)
  }

  getRemessas(os: string){
    return this.httpClient.get<Remessa[]>(`${this.configService.getApiUrlRoot()}/painelinsumos/remessas/${os}`)
  }

  getDeposito(id: string){
    return this.httpClient.get<DepositoInsumo>(`${this.configService.getApiUrlRoot()}/painelinsumos/depositos/${id}`)
  }

  putPosicao(posicao: DepositoInsumoPosicao){
    return this.httpClient.put(`${this.configService.getApiUrlRoot()}/painelinsumos/depositos/posicao`, posicao);
  }

  postPosicao(posicao: DepositoInsumoPosicao){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/painelinsumos/depositos/posicao`, posicao)
  }

  getSyncOrdens(){
    return this.httpClient.get<OrdemInsumo[]>(`${this.configService.getApiUrlRoot()}/painelinsumos/sincronizar`);
  }

  getEstoqueErp(id: string, deposito?: string){

    if(deposito == undefined) deposito = ""

    return this.httpClient.get<EstoqueErpOS[]>(`${this.configService.getApiUrlRoot()}/painelinsumos/consultaestoqueerp/${id}?deposito=${deposito}`);
  }

  getRelatorio(tipo: string){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/painelinsumos/gerarRelatorio/${tipo}`, { responseType: 'blob'});
  }


  getListMaterialDeposito(){
    return this.httpClient.get<MaterialDeposito[]>(`${this.configService.getApiUrlRoot()}/painelinsumos/insumosExcecao`);
  }

  getMaterialDeposito(id: string){
    return this.httpClient.get<MaterialDeposito>(`${this.configService.getApiUrlRoot()}/painelinsumos/insumosExcecao/${id}`);
  }

  postMaterialDeposito(materialDeposito: MaterialDeposito){
    return this.httpClient.post<MaterialDeposito>(`${this.configService.getApiUrlRoot()}/painelinsumos/insumosExcecao`, materialDeposito);
  }

  putMaterialDeposito(materialDeposito: MaterialDeposito){
    return this.httpClient.put<MaterialDeposito>(`${this.configService.getApiUrlRoot()}/painelinsumos/insumosExcecao`, materialDeposito);
  }

  deleteMaterialDeposito(id: string){
    return this.httpClient.delete(`${this.configService.getApiUrlRoot()}/painelinsumos/insumosExcecao/${id}`);
  }

  getListEmpresasPainel(){
    return this.httpClient.get<EmpresaPainel[]>(`${this.configService.getApiUrlRoot()}/painelinsumos/empresas`);
  }

  getEmpresaUsuario(email: string){
    return this.httpClient.get<EmpresaPainel[]>(`${this.configService.getApiUrlRoot()}/painelinsumos/empresas/usuario/${email}`);
  }

  postEmpresaUsuario(email: string, empresas: string[]){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/painelinsumos/empresas/usuario/${email}`, empresas);
  }

  postCancelarRemessa(id: string, usuario: string){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/painelinsumos/remessas/cancelar/${id}?usuario=${usuario}`, null);
  }

  exportarRelatorio(corpo: any): Observable<any>{
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/painelinsumos/relatorios`, corpo, { responseType: 'blob'});
  }
}
